import React from 'react';

const EmptyState = ({ message }) => {
  return (
    <div className="bg-card rounded-lg shadow-gaming-md p-6">
      <p className="text-sm text-muted-foreground caption">{message}</p>
    </div>
  );
};

export default EmptyState;
